import React, { useState, useEffect } from "react";
import { storage, ref, uploadBytes, getDownloadURL, listAll } from "./FireBase";
import "./ImagePage.css"; 
import { useNavigate, useLocation } from "react-router-dom";


const ImagePage = () => {

  const [files, setFiles] = useState([]);



  const fetchFiles = async () => {
    try {
      const listRef = ref(storage, "uploads/"); 
      const result = await listAll(listRef);
  
      // Fetch filenames, URLs, and categorize by file type
      const filesData = await Promise.all(
        result.items.map(async (item) => {
          const url = await getDownloadURL(item);
          const filename = item.name;
  
          // Extract file extension
          const extension = filename.split('.').pop().toLowerCase();
  
          // Define categories based on extensions
          let fileType = "other"; // Default category
          const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
          const videoExtensions = ["mp4", "mkv", "avi", "mov", "wmv", "flv"];
  
          if (imageExtensions.includes(extension)) {
            fileType = "image";
          } else if (videoExtensions.includes(extension)) {
            fileType = "video";
          }
  
          return { filename, url, fileType };
        })
      );
  
      console.log(filesData);
      setFiles(filesData);  // Update state with categorized files
    } catch (error) {
      console.error("Error fetching files:", error);
    }
  };
  

  useEffect(() => {
    fetchFiles();
  }, []);

  return (
<div className="outerimagecontainer">
  <h2>Images</h2>

  <div className="filesimage-container">
    {files
      .filter((file) => file.fileType === "image") // Ensure only images are shown
      .map((file, index) => (
        <div className="imagecontainer" key={index}>
          <div className="innerimagecontainer">
            <img src={file.url} alt={file.filename} />
          </div>
          <p>{file.filename}</p>
        </div>
      ))}
  </div>
</div>

  );
};

export default ImagePage;
